module.exports = __webpack_public_path__ + "static/media/logo-selecthealth-bw-txt.01b4f39f.svg";